var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13.222,
    viewBox: "0 0 12 13.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-calendar",
    "data-name": "Icon feather-calendar",
    transform: "translate(-4 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M5.722,6h8.556A1.222,1.222,0,0,1,15.5,7.222v8.556A1.222,1.222,0,0,1,14.278,17H5.722A1.222,1.222,0,0,1,4.5,15.778V7.222A1.222,1.222,0,0,1,5.722,6Z",
    transform: "translate(0 -1.778)",
    fill: "none",
    stroke: "#0f0f0f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M24,3V5.444",
    transform: "translate(-11.556 0)",
    fill: "none",
    stroke: "#0f0f0f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M12,3V5.444",
    transform: "translate(-4.444 0)",
    fill: "none",
    stroke: "#0f0f0f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M4.5,15h11",
    transform: "translate(0 -7.111)",
    fill: "none",
    stroke: "#0f0f0f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1aba553860f228dab0cc76602ab1d7a2.svg";
export { ForwardRef as ReactComponent };